export default __webpack_public_path__ + "static/media/BolsImg.acf02bc6.svg";